import i18next from "i18next"

import en_gb_layout from "./engb/layout.json"
import it_it_layout from "./itit/layout.json"
import es_es_layout from "./eses/layout.json"
import fr_fr_layout from "./frfr/layout.json"

import en_gb_generics from "./engb/generics.json"
import it_it_generics from "./itit/generics.json"
import es_es_generics from "./eses/generics.json"
import fr_fr_generics from "./frfr/generics.json"

import it_it_insight from "./itit/insight.json"
import en_gb_insight from "./engb/insight.json"
import es_es_insight from "./eses/insight.json"
import fr_fr_insight from "./frfr/insight.json"

import it_it_pages from "./itit/pages.json"
import en_gb_pages from "./engb/pages.json"
import es_es_pages from "./eses/pages.json"
import fr_fr_pages from "./frfr/pages.json"

import it_it_support from "./itit/support.json"
import en_gb_support from "./engb/support.json"
import es_es_support from "./eses/support.json"
import fr_fr_support from "./frfr/support.json"

import it_it_forms from "./itit/forms.json"
import en_gb_forms from "./engb/forms.json"
import es_es_forms from "./eses/forms.json"
import fr_fr_forms from "./frfr/forms.json"

i18next.init({
  lng: 'it-it',
  returnNull: true,
  interpolation: { escapeValue: false },
  resources: {
    engb: {
      layout: en_gb_layout,
      generics: en_gb_generics,
      insight: en_gb_insight,
      pages: en_gb_pages,
      support: en_gb_support,
      forms: en_gb_forms
    },
    itit: {
      layout: it_it_layout,
      generics: it_it_generics,
      insight: it_it_insight,
      pages: it_it_pages,
      support: it_it_support,
      forms: it_it_forms
    },
    eses: {
      layout: es_es_layout,
      generics: es_es_generics,
      insight: es_es_insight,
      pages: es_es_pages,
      support: es_es_support,
      forms: es_es_forms
    },
    frfr: {
      layout: fr_fr_layout,
      generics: fr_fr_generics,
      insight: fr_fr_insight,
      pages: fr_fr_pages,
      support: fr_fr_support,
      forms: fr_fr_forms
    }
  },
})

export default i18next